import styled from 'styled-components';

import { ASCENDING, DESCENDING } from 'constants/sortDirections';

import { TableHeaderCell } from './TableHeaderCell';

const StyledHeader = styled.div`
  background: #fcfcfc;
  border-color: #eaeaea;
  border-style: solid;
  border-width: 0;
  border-top-width: 1px;
  display: table-row;
  width: 100%;
`;

// type Props = {
//   columns: Any,
//   setSortedBy: (id: string) => void,
//   setSortDirection: (dir: string) => void,
//   sortedBy: String,
//   sortDirection: SortDirections from 'constants/sortDirections'; ,
// };

export const TableHeader = ({
  columns,
  setSortedBy,
  setSortDirection,
  sortedBy,
  sortDirection,
  ...props
}) => {
  if (!columns.length) {
    return null;
  }

  return (
    <StyledHeader data-test="table-header-row" role="row" {...props}>
      {columns.map((col) => {
        if (col.renderHeaderCell) {
          return col.renderHeaderCell(col);
        }

        const id = col.value;
        const isActiveSort = sortedBy === id; // if this column is the active sorting index
        return (
          <TableHeaderCell
            isActiveSort={isActiveSort}
            columnData={col}
            key={id}
            handleClick={() => {
              if (isActiveSort) {
                const newSortDirection = sortDirection === ASCENDING ? DESCENDING : ASCENDING;
                setSortDirection(newSortDirection);
              } else {
                setSortedBy(id);
              }
            }}
            sortable={!!col.sortable}
            sortDirection={sortDirection}
          />
        );
      })}
    </StyledHeader>
  );
};
